import { Injectable } from '@angular/core';
import { QuestionnaireSchema, QuestionnaireSection, QuestionnaireTab } from '@mds/common';

@Injectable()
export class QuestionnairesValidatorService {
  /**
   * Validates all tabs except the initial thread and logs invalid sections.
   * @param allTabs - The array of all tabs to validate.
   */
  checkValidity(allTabs: QuestionnaireTab[]): string[] {
    const validTabs = allTabs.filter((tab) => tab.key !== 'initial_thread' && !tab.isGrid);
    const invalidSections: Record<string, Record<string, string[]>> = {};

    validTabs.forEach((tab) => {
      const invalidForms = this.checkSections(tab.sections);
      if (Object.keys(invalidForms).length > 0) {
        invalidSections[tab.key] = invalidForms;
      }
    });

    return Object.keys(invalidSections);
  }

  /**
   * Validates all sections in a tab.
   * @param sections - The array of sections to validate.
   * @returns An object with invalid forms for each section.
   */
  checkSections(sections: QuestionnaireSection[]): Record<string, string[]> {
    const invalidSections: Record<string, string[]> = {};

    sections.forEach((section) => {
      const schema = section.formSchema.filter((e) => !['disabled', 'display_only', 'hidden'].includes(e.formtype));
      const invalidForms = section.actions.edit ? this.checkForm(schema) : [];
      if (invalidForms.length) {
        invalidSections[section.name] = invalidForms;
      }
    });
    return invalidSections;
  }

  /**
   * Checks each form schema in a section and returns the keys of invalid forms.
   * @param schema - The array of form schemas to check.
   * @returns An array of keys for invalid forms.
   */
  checkForm(schema: QuestionnaireSchema[]): string[] {
    const invalidFormList: string[] = [];
    const numericTypes = ['int', 'FLOAT', 'float', 'DOUBLE'];

    schema.forEach((form) => {
      const isEmptyValue = form.defaultValue === null || form.defaultValue === undefined || form.defaultValue === '';

      if ((numericTypes.includes(form.fieldtype) && isEmptyValue) || (!numericTypes.includes(form.fieldtype) && !form.defaultValue)) {
        invalidFormList.push(form.key);
      }
    });
    return invalidFormList;
  }
}
